/**
 * Deployment realm for the SPA (CLA-859).
 *
 * The edge Worker routes claro.clinic by the `claro_realm` cookie, but that
 * cookie is HttpOnly — the SPA cannot read it. Instead the auth store persists
 * the realm reported by the backend on session bootstrap (see stores/auth.ts).
 * Unknown/absent → 'au', so the AU deployment behaves exactly as before this
 * helper existed.
 *
 * Signed-out public pages take the realm from the deployment that answered
 * them instead (`lib/served-realm.ts`, CLA-1829).
 *
 * This module is realm IDENTITY only. All jurisdictional vocabulary (labels,
 * locale, tax, timezones, …) lives in lib/jurisdiction.ts, which uses the
 * realm solely to key its pre-auth / old-backend builtin fallback.
 */

export type Realm = 'au' | 'us'

const STORAGE_KEY = 'claro:realm'

/** The realm this session belongs to. Defaults to 'au'. */
export function getRealm(): Realm {
  try {
    const v = localStorage.getItem(STORAGE_KEY)
    if (v === 'au' || v === 'us') return v
  } catch {
    /* storage unavailable — fall through to default */
  }
  return 'au'
}

/** Persist the realm reported by the backend. Ignores unknown values. */
export function setRealm(realm: string | null | undefined): void {
  if (realm !== 'au' && realm !== 'us') return
  try {
    localStorage.setItem(STORAGE_KEY, realm)
  } catch {
    /* storage unavailable — getRealm() falls back to 'au' */
  }
}

